import { FC, Fragment } from 'react';

import { useAtomValue } from 'jotai';
import useSWR from 'swr';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { AddStoreProductButton } from './addStoreProductButton/AddStoreProductButton';
import { StoreTab } from './constants';
import { ExportStoreHistoryButton } from './exportStoreHistoryButton/ExportStoreHistoryButton';
import { StoreHistory } from './storeHistory/StoreHistory';
import { StoreProducts } from './storeProducts/StoreProducts';

import css from './StorePage.module.css';

import { storeService } from 'v2/api/storeService';
import { isUserAdminAtom } from 'v2/atoms/userAtom';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { useTabs } from 'v2/hooks/useTabs';

export const StorePage: FC = () => {
  const { activeTab, onTabChange } = useTabs<StoreTab>(StoreTab.PRODUCTS);

  const isUserAdmin = useAtomValue(isUserAdminAtom);

  const { data, isLoading, mutate } = useSWR(
    activeTab === StoreTab.PRODUCTS && 'getStoreProducts',
    storeService.getStoreProducts
  );

  return (
    <PageLayout className={css.storePage} overflow="hidden">
      <PageTitle
        action={
          activeTab === StoreTab.PRODUCTS && isUserAdmin ? (
            <AddStoreProductButton onSuccess={mutate} />
          ) : (
            <ExportStoreHistoryButton />
          )
        }
      >
        Store
      </PageTitle>

      {isUserAdmin ? (
        <Fragment>
          <Tabs value={activeTab} onChange={(_, v) => onTabChange(v)}>
            <Tab value={StoreTab.PRODUCTS} label="Products" />
            <Tab value={StoreTab.HISTORY} label="History" />
          </Tabs>

          {activeTab === StoreTab.PRODUCTS && <StoreProducts isLoading={isLoading} data={data} onRevalidate={mutate} />}
          {activeTab === StoreTab.HISTORY && <StoreHistory />}
        </Fragment>
      ) : (
        <StoreHistory />
      )}
    </PageLayout>
  );
};
